var Adapter, Q, _, adapters, lookupAdapter, presenter, presenterFactory, utils;

if (typeof window !== "undefined" && window !== null) {
  Q = window.Q;
  _ = window._;
}

Q || (Q = ((function() {
  try {
    return typeof require === "function" ? require('q') : void 0;
  } catch (_error) {}
})()));

_ || (_ = ((function() {
  try {
    return typeof require === "function" ? require('lodash') : void 0;
  } catch (_error) {}
})()));

_ || (_ = ((function() {
  try {
    return typeof require === "function" ? require('underscore') : void 0;
  } catch (_error) {}
})()));

utils = require('./yayson/utils')(_, Q);

Adapter = require('./yayson/adapter');

adapters = require('./yayson/adapters');

presenterFactory = require('./yayson/presenter');

lookupAdapter = function(nameOrAdapter) {
  if (nameOrAdapter === 'default') {
    return Adapter;
  }
  return adapters[nameOrAdapter] || nameOrAdapter || Adapter;
};

presenter = function(options) {
  var adapter;
  if (options == null) {
    options = {};
  }
  adapter = lookupAdapter(options.adapter);
  return presenterFactory(utils, adapter);
};

module.exports = function(arg) {
  var adapter;
  adapter = (arg != null ? arg : {}).adapter;
  return {
    Store: require('./yayson/store')(utils),
    Presenter: presenter({
      adapter: adapter
    }),
    Adapter: Adapter
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/yayson/lib/yayson.js
// module id = avjC
// module chunks = 3